<template>
  <el-dialog
    title="发券"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    @close="clearBeforeClose"
  >
    <el-form :model="form" label-width="100px" :rules="rules" ref="form">
      <el-form-item label="发放对象" prop="shopId">
        <el-select
          v-model="form.shopId"
          remote
          placeholder="请输入客户名称"
          filterable
          reserve-keyword
          :remote-method="remoteMethodForMerchant"
          :loading="loadingForMerchant"
          clearable
        >
          <el-option
            v-for="item in optionsForMerchant"
            :key="item.id"
            :label="`${item.provinceName || ''}/${item.cityName || ''}/${
              item.areaName || ''
            }/${item.shopName}`"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发券数量" prop="numbers">
        <el-input
          v-model.number="form.numbers"
          placeholder="请输入发券数量"
          type="number"
          min="1"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { fuzzySearchMerchant, sendCouponToShop } from "@/api/coupon";
export default {
  data() {
    return {
      dialogVisible: false,
      loadingForMerchant: false,
      form: {
        couponCode: "", //优惠券编码
        shopId: "", //店铺id
        numbers: 1, //发券数量
      },
      optionsForMerchant: [],
      rules: {
        shopId: [
          { required: true, message: "请选择发放对象", trigger: "blur" },
        ],
        numbers: [
          { required: true, message: "请填写发券数量", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (typeof value !== "number" || isNaN(value)) {
                callback(new Error("请输入正确的数字"));
              } else if (value < 1) {
                callback(new Error("发券数量不能小于1"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    clearBeforeClose() {
      this.form.couponCode = "";
      this.form.shopId = "";
      this.form.numbers = 1;
      this.optionsForMerchant = [];
    },
    publicOpen(item) {
      this.form.couponCode = item.couponCode;
      this.dialogVisible = true;
    },
    remoteMethodForMerchant(queryString) {
      this.loadingForMerchant = true;
      let params = {};
      let restaurants = [];
      params.name = queryString;
      // 根据店铺名或手机号搜索店铺
      fuzzySearchMerchant(params)
        .then((res) => {
          if (res) {
            restaurants = res;
            if (queryString !== "") {
              this.optionsForMerchant = restaurants;
            } else {
              this.optionsForMerchant = [];
            }
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loadingForMerchant = false;
        });
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          sendCouponToShop(this.form).then((res) => {});
          // 这里可以添加发券逻辑
          this.$message.success("发券成功");
          this.dialogVisible = false;
          this.$nextTick(() => {
            this.$emit("sendCouponSuccess");
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
